import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Aanbiedingsdetails',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Stel het kwalificerende bedrag en de % korting in',
      qualifying_criteria: {
        title: 'Minimaal bestelbedrag',
        description: 'Stel het kwalificerende bestelbedrag in',
      },
      details: {
        title: '% korting',
        description: 'Stel de korting in die klanten op hun bestelling krijgen',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Stel de kwalificerende artikelen en de % korting in',
      qualifying_criteria: {
        title: 'Artikelen met korting',
        description: 'Selecteer de artikelen waarop u korting biedt.',
      },
      details: {
        title: '% korting',
        description: 'Stel de korting in die klanten op hun bestelling krijgen',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Stel de kwalificerende artikelen en de {{currency}} korting in',
      qualifying_criteria: {
        title: 'Artikelen met korting',
        description: 'Selecteer de artikelen waarop u korting biedt.',
      },
      details: {
        title: '{{currency}} korting',
        description: 'Stel de korting in die klanten op hun bestelling krijgen',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Stel het kwalificerende bedrag en de {{currency}} korting in',
      qualifying_criteria: {
        title: 'Minimaal bestelbedrag',
        description: 'Stel het kwalificerende bestelbedrag in',
      },
      details: {
        title: '{{currency}} korting',
        description: 'Stel de korting in die klanten op hun bestelling krijgen',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Stel het kwalificerende bedrag en gratis artikelen in',
      qualifying_criteria: {
        title: 'Minimaal bestelbedrag',
        description: 'Stel het bedrag in dat de klant moet besteden voor het gratis artikel.',
      },
      details: {
        title: 'Gratis artikelen:',
        description: 'Selecteer het gratis artikel (of artikelen) waaruit de klant er één kan kiezen.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Kies de vereisten voor de aanbieding',
      qualifying_criteria: {
        title: 'Kwalificerende artikelen',
        description: 'Selecteer de artikelen die de klant moet bestellen om het gratis artikel te krijgen.',
      },
      details: {
        title: 'Gratis artikelen:',
        description: 'Selecteer het gratis artikel (of artikelen) waaruit de klant er één kan kiezen.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Kies de vereisten voor de aanbieding',
      qualifying_criteria: {
        title: 'Kwalificerende artikelen',
        description: 'Selecteer de categorie waaruit de klant moet kiezen om een gratis artikel te krijgen.',
      },
      details: {
        title: 'Gratis artikel',
        description:
          'Klanten kunnen hun tweede artikel kiezen uit de geselecteerde kwalificerende artikelen. De klant krijgt het goedkoopste van de twee artikelen gratis.',
      },
    },
  },
};
